export default __webpack_public_path__ + "static/media/hub_mobile.df79b595.svg";